<template>
    <transition name="slide-right">
        <div class="content">
            <div class="content-wrapper" v-if="bookavailable">
                <div  class="content-item" v-for="(item,index) in resss" :key="index" @click="jumptos(item.href)">
                    <span class="text">{{item.label}}</span>
                </div>

            </div>
            <div class="empty" v-else>加载中...</div>
        </div>
    </transition>



</template>

<script>

    export default {
        props:["isshowconten","navigation","bookavailable"],
        name: "contentview",
        data() {
            return {
                    mulu:'',
                    resss:[],
            }
        },
        created() {

        },
        watch: {
            navigation(val) {
                var arr = this.navigation.toc
                var that=this
                this.resss=[]
                function flatten(arr){

                    for(var i=0;i<arr.length;i++){
                        if(arr[i].subitems.length==0){
                            that.resss.push(arr[i])
                        }else{
                            that.resss.push(arr[i])
                            flatten(arr[i].subitems)
                        }
                    }
                    return that.resss;
                }
                flatten(arr)
                // console.log(JSON.stringify(flatten(arr)))
                // this.value = this.demo;
            }
        },
        mounted() {




        },
        methods: {
            jumptos(href){
                // alert(JSON.stringify(href))
                this.$emit('jumpto',href)
            }
        },
    }
</script>

<style scoped lang="scss">
    @import '../assets/styles/global.scss';
    .content {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 102;
        width: 80%;
        height: 100%;
        background-color: #fff;
        .content-wrapper {
            width: 100%;
            height: 100%;
            overflow: auto;
            .content-item {
                padding: px2rem(20) px2rem(15);
                border-bottom: px2rem(1) solid #ccc;
                .text {
                    font-size: px2rem(14);
                    color: #333;
                }
            }
        }
        .empty {
            width: 100%;
            height: 100%;
            @include center;
            font-size: px2rem(16);
            color: #333;
        }
    }



</style>


// WEBPACK FOOTER //
// src/components/contentview.vue